var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShotVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0227 14.4602C14.9173 14.5657 14.7742 14.625 14.625 14.625H3.375C3.22582 14.625 3.08274 14.5657 2.97725 14.4602C2.87176 14.3548 2.8125 14.2117 2.8125 14.0625V7.875H15.1875V8.71875",
    stroke: "#606479",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81256 7.87501L14.7657 4.66876L14.1821 2.4961C14.1634 2.4246 14.1306 2.35754 14.0856 2.29887C14.0407 2.2402 13.9845 2.19109 13.9203 2.15442C13.8561 2.11775 13.7853 2.09426 13.7119 2.08532C13.6385 2.07638 13.5641 2.08217 13.493 2.10235L2.62974 5.01329C2.5581 5.03208 2.49088 5.06483 2.43193 5.10967C2.37298 5.15451 2.32346 5.21055 2.28623 5.27457C2.24899 5.33859 2.22476 5.40934 2.21493 5.48275C2.20511 5.55616 2.20987 5.63079 2.22896 5.70235L2.81256 7.87501Z",
    stroke: "#606479",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14758 3.26248L12.5929 5.25233",
    stroke: "#606479",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26086 4.57736L7.69915 6.56721",
    stroke: "#606479",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9625 12.3167L15.9075 9.448H16.9133L15.5295 13.1875H14.382L13.005 9.448H14.0175L14.9625 12.3167Z",
    fill: "#606479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotVersion);
export default __webpack_public_path__ + "static/media/ShotVersion.9fd9d8c46228add9a2aefb012deed714.svg";
export { ForwardRef as ReactComponent };